// src/hooks/useSuggestions.js

import { useState, useEffect } from 'react';

const useSuggestions = (animes, field) => {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const uniqueValues = new Set();
    animes.forEach(anime => {
      if (field === 'studio' && anime.studio) uniqueValues.add(anime.studio);
      if (field === 'director' && anime.director) uniqueValues.add(anime.director);
      if (field === 'streamingSite' && anime.streamingSite) uniqueValues.add(anime.streamingSite);
      if (field === 'opArtist' && anime.opSong?.artist) uniqueValues.add(anime.opSong.artist);
      if (field === 'edArtist' && anime.edSong?.artist) uniqueValues.add(anime.edSong.artist);
    });
    setSuggestions(Array.from(uniqueValues));
  }, [animes, field]);

  return suggestions;
};

export default useSuggestions;
